<form [formGroup]="formGroup" class="flex justify-between content-stretch items-stretch flex-col h-full">
  <div class="flex-grow mb-4">
    <h1 mat-dialog-title tabindex="0" class="!flex justify-between items-end">
      <span class="flex-grow">Edit Site</span>
      <mat-icon *ngIf="fieldsLocked" class="lock-icon" [matTooltip]="lockTooltip">lock</mat-icon>
    </h1>
    <mat-dialog-content class="edit-site-container !h-full">
      <div class="flex flex-col gap-4">
        <div class="flex justify-between flex-grow gap-4">
          <!-- Salesforce Autocomplete -->
          <mat-form-field floatLabel="never" class="autocomplete w-full" appearance="fill">
            <label for="salesforceName">
              <app-icon icon="asterisk" size="10" aria-hidden="true"></app-icon>
              Site Name From Salesforce
            </label>
            <input type="text" formControlName="salesforceName" placeholder="Find site by name or customer number"
              id="salesforceName" matInput [matAutocomplete]="salesforce">
            <mat-autocomplete #salesforce="matAutocomplete" [displayWith]="getSiteName.bind(this)">
              <mat-option *ngFor="let option of siteOptionswithfilter" (onSelectionChange)="fetchSalesforceDetails(option)"
                [value]="option.id" [disabled]="option.isOnboarded">
                <div *ngIf="option.isOnboarded">
                  <span matTooltip="{{option.name}} ({{option.customer_Num__c}})" matTooltipPosition="after"
                    matTooltipClass="custom_tooltip" *ngIf="option.customer_Num__c" class="option-text">
                    {{option.name}} ({{ option.customer_Num__c }})
                  </span>
                  <span matTooltip="{{option.name}}" matTooltipPosition="after" matTooltipClass="custom_tooltip"
                    *ngIf="!option.customer_Num__c" class="option-text">
                    {{option.name}}
                  </span>
                  <span style="float: right;overflow: hidden;text-overflow: ellipsis;max-width: 32%;">
                    ONBOARDED
                  </span>
                </div>
                <div *ngIf="!option.isOnboarded">
                  <span matTooltip="{{option.name}} ({{option.customer_Num__c}})" matTooltipPosition="after"
                    matTooltipClass="custom_tooltip" *ngIf="option.customer_Num__c">
                    {{option.name}} ({{ option.customer_Num__c }})
                  </span>
                  <span matTooltip="{{option.name}}" matTooltipPosition="after" matTooltipClass="custom_tooltip"
                    *ngIf="!option.customer_Num__c">
                    {{option.name}}
                  </span>
                </div>
              </mat-option>
            </mat-autocomplete>
            <mat-error>{{ getSalesforceErrorMessage() }}</mat-error>
          </mat-form-field>

          <!-- Friendly Name -->
          <mat-form-field floatLabel="never" class="w-full">
            <label for="siteName">
              <app-icon icon="asterisk" size="10" aria-hidden="true"></app-icon>
              <span>Site Name</span>
            </label>
            <input matInput id="siteName" formControlName="name">
            <mat-error *ngIf="formGroup.get('name').hasError('required')">Site name is required</mat-error>
          </mat-form-field>
        </div>

        <div class="flex justify-between flex-grow gap-4">
          <!-- Incada Location Selects -->
          <app-incada-location-select class="flex-1" 
            *ngIf="showIncadaControls"
            [form]="formGroup" 
            [controlName]="'incadaSite'" 
            [orgUnits]="false"
            [disabled]="fieldsLocked && incadaEnabled" 
            [incadaTenantSlug]="parentIncadaTenantSlug"
            [incadaRegionSlug]="parentIncadaRegionSlug" 
            (locationSelected)="onIncadaSiteSelected($event)">
          </app-incada-location-select>

          <app-incada-location-select  class="flex-1" 
            *ngIf="showIncadaControls"
            [form]="formGroup" 
            [controlName]="'incadaOrgUnit'" 
            [orgUnits]="true"
            [disabled]="fieldsLocked && incadaEnabled" 
            [incadaTenantSlug]="parentIncadaTenantSlug"
            [incadaRegionSlug]="parentIncadaRegionSlug" 
            (locationSelected)="onIncadaOrgUnitSelected($event)">
          </app-incada-location-select>
        </div>
      </div>
    </mat-dialog-content>
  </div>
  <mat-dialog-actions class="!py-4 flex flex-row justify-end content-end items-end w-full">
    <button mat-button class="btn-default btn-md" (click)="closePopup()" id="cancel_edit_site">Cancel</button>
    <button mat-button class="btn-primary btn-md" [disabled]="!deviceCheckComplete" (click)="save()"
      id="save_edit_site">Save</button>
  </mat-dialog-actions>
</form>